// Miscellaneous Style Plugin (for properties that don't fit other categories)
export default {
    id: 'misc',
    label: 'Miscellaneous',
    icon: 'MoreHorizontal',
    properties: {
        content: {
            label: 'Content',
            type: 'select',
            options: ['none'],
            default: 'none',
            toClass: (value) => value ? `content-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^content-(none)$/);
                return match ? match[1] : null;
            }
        }
    }
};
